import React from 'react';
import { Link } from 'react-router-dom';

const RojgarMitra: React.FC = () => {
  return (
    <div className="rojgar-mitra-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">ROJGAR MITRA</h1>
          <p className="text-white text-xl mb-4 animate-fadeInUp">A Workforce & Employment Initiative</p>
          <p className="text-secondary text-lg animate-fadeInUp">by NEXEDZ PRIVATE LIMITED</p>
          <nav className="flex justify-center animate-fadeInUp mt-4">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/services-for-bharat" className="hover:text-secondary">Services for Bharat</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Rojgar Mitra</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-6">Connecting Skills with Opportunities</h2>
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Rojgar Mitra is a dedicated workforce and employment support initiative under Nexedz Private Limited, designed to connect skilled individuals with meaningful job opportunities across Bharat. Our mission is to reduce the gap between job seekers and employers by providing a streamlined, reliable, and accessible employment ecosystem.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                At <strong>Rojgar Mitra</strong>, we believe that every individual deserves the chance to build a stable and successful career. With a strong network of industries, training partners, and employers, we play a vital role in enabling livelihood opportunities for youth across the country.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Vision */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-eye text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-center">Our Vision</h3>
                <p className="text-gray-700 text-lg leading-relaxed text-center">
                  To become <strong>Bharat's most trusted employment bridge</strong> by empowering youth with opportunities that match their skills, passion, and potential.
                </p>
              </div>

              {/* Mission */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-bullseye text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4 text-center">Our Mission</h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To support job seekers with skill-based employment opportunities</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To assist employers in finding the right talent efficiently</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To connect skilled individuals from Edge Infotech training programs with real industry jobs</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To strengthen workforce development through guidance, training, and placement support</span>
                  </li>
                  <li className="flex items-start">
                    <i className="fas fa-check-circle text-secondary text-xl mr-3 mt-1"></i>
                    <span>To contribute to the mission of Skill India & Self-Reliant Bharat</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Do Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">What We Do</h2>
            </div>

            <div className="space-y-8">
              {/* Service 1 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp">
                <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
                  <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-handshake text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">1. Job Matching & Placement Services</h3>
                    <p className="text-gray-700 text-lg">
                      We connect candidates with verified employers based on skill, experience, and career goals.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service 2 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
                  <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-users text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">2. Workforce Solutions for Employers</h3>
                    <p className="text-gray-700 text-lg">
                      Rojgar Mitra helps organizations hire trained, job-ready candidates across multiple sectors.
                    </p>
                  </div>
                </div>
              </div>

              {/* Service 3 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
                  <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-clipboard-list text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">3. Career Guidance & Support</h3>
                    <p className="text-gray-700 text-lg mb-4">We provide:</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Resume building</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Interview preparation</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Soft-skill enhancement</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Job readiness training</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Service 4 */}
              <div className="bg-white rounded-lg shadow-lg p-8 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
                  <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="fas fa-user-friends text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold mb-3">4. Employment for All</h3>
                    <p className="text-gray-700 text-lg mb-4">We support:</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Skilled and semi-skilled youth</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Freshers</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Rural and urban job seekers</span>
                      </div>
                      <div className="flex items-center">
                        <i className="fas fa-check text-secondary mr-2"></i>
                        <span className="text-gray-700">Women seeking career opportunities</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Rojgar Mitra Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-4">Why Rojgar Mitra?</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp">
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-network-wired text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Strong Employer Network</h4>
                <p className="text-gray-600 text-center">
                  Extensive connections with verified employers across Bharat
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.1s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-shield-alt text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Transparent & Reliable</h4>
                <p className="text-gray-600 text-center">
                  Trustworthy placement process with verified opportunities
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user-graduate text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Job-Ready Candidates</h4>
                <p className="text-gray-600 text-center">
                  Trained professionals from Edge Infotech programs
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.3s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-laptop text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Digital Job Search Support</h4>
                <p className="text-gray-600 text-center">
                  Modern platform for seamless job searching
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
                <div className="bg-primary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-user-check text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Personalized Guidance</h4>
                <p className="text-gray-600 text-center">
                  Individual attention and career counseling for every candidate
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.5s' }}>
                <div className="bg-secondary text-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="fas fa-chart-line text-2xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-3 text-center">Youth Empowerment</h4>
                <p className="text-gray-600 text-center">
                  Commitment to economic growth and skill development
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Our Commitment Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto">
            <div className="text-center mb-12 animate-fadeInUp">
              <h2 className="text-4xl font-bold mb-6">Our Commitment</h2>
            </div>

            <div className="bg-gradient-to-r from-primary to-secondary text-white rounded-lg shadow-2xl p-12 text-center animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <p className="text-2xl leading-relaxed mb-6">
                <strong>Rojgar Mitra is not just a job portal</strong>
              </p>
              <p className="text-xl leading-relaxed mb-8">
                It is a mission to create employment, uplift communities, and empower the future workforce of Bharat.
              </p>
              <div className="border-t-2 border-white my-8 max-w-md mx-auto"></div>
              <p className="text-lg leading-relaxed">
                As a proud part of <strong>Nexedz Private Limited</strong>, we work to ensure that every skilled individual finds a meaningful career opportunity and every employer finds the right talent.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Sections */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* For Job Seekers */}
              <div className="bg-white rounded-lg shadow-lg p-8 text-center animate-fadeInUp">
                <div className="bg-primary text-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-user-tie text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">For Job Seekers</h3>
                <p className="text-gray-600 mb-6">
                  Find your dream job and start building your career today
                </p>
                <Link
                  to="/contact"
                  className="bg-primary hover:bg-secondary text-white font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
                >
                  Register for Jobs
                </Link>
              </div>

              {/* For Employers */}
              <div className="bg-white rounded-lg shadow-lg p-8 text-center animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
                <div className="bg-secondary text-white w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className="fas fa-building text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">For Employers</h3>
                <p className="text-gray-600 mb-6">
                  Find skilled, job-ready candidates for your organization
                </p>
                <Link
                  to="/contact"
                  className="bg-secondary hover:bg-primary text-white font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
                >
                  Post Requirements
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-20 bg-gradient-to-r from-primary to-secondary">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold text-white mb-6 animate-fadeInUp">
            Building Careers. Transforming Lives.
          </h2>
          <p className="text-white text-xl mb-8 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
            Join Rojgar Mitra and be part of Bharat's employment revolution
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/contact"
              className="bg-white text-primary hover:bg-gray-100 font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Get Started Today
            </Link>
            <Link
              to="/contact"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-primary font-semibold py-4 px-8 rounded-full transition duration-300 inline-block"
            >
              Learn More
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RojgarMitra;